'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _plugin = require('../../plugin');
var _plugin2 = _interopRequireDefault(_plugin);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }
    return arr2;
  } else {
    return Array.from(arr);
  }
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var MessageQueue = function (_Plugin) {
  _inherits(MessageQueue, _Plugin);
  function MessageQueue(entity) {
    _classCallCheck(this, MessageQueue);
    var _this = _possibleConstructorReturn(this, (MessageQueue.__proto__ || Object.getPrototypeOf(MessageQueue)).call(this, entity));
    _this.listByRoom = {};
    return _this;
  }
  _createClass(MessageQueue, [{
    key: 'add',
    value: function add(message) {
      var id = message.id,
        roomname = message.roomname;
      this._removeMessageInRoom(roomname, id);
      this.listByRoom[roomname] = [].concat(_toConsumableArray(this.listByRoom[roomname] || []), [message]);
    }
  }, {
    key: 'flush',
    value: function flush(roomname) {
      if (!(roomname in this.listByRoom)) {
        return [];
      }
      var messages = this.listByRoom[roomname];
      delete this.listByRoom[roomname];
      return messages;
    }
  }, {
    key: '_removeMessageInRoom',
    value: function _removeMessageInRoom(roomname, messageId) {
      var list = this.listByRoom[roomname] || [];
      var willRemoveIndex = list.findIndex(function (_ref) {
        var id = _ref.id;
        return id === messageId;
      });
      if (willRemoveIndex >= 0) {
        list.splice(willRemoveIndex, 1);
      }
    }
  }]);
  return MessageQueue;
}(_plugin2.default);
MessageQueue.pluginName = 'messageQueue';
exports.default = MessageQueue;